
export function mapBackendProceduresToFrontend (procedures) {
  return procedures?.map(proc => {
    const [auto, manual] = proc.participantsCount?.split('/').map(Number)
    return {
      id: proc.id,
      title: proc.title,
      direction: proc.type === 'BUY' ? 1 : 2,
      status: proc.stateId,
      manager: proc.managerId,
      company: 0,
      participants_count: +auto + +manual,
      participants_auto: +auto,
      participants_manual: +manual,
      product_count: proc.productCount,
      date_created: proc.dateCreated,
      date_open: proc.dateOpen,
      date_agreement: proc.dateAgreement,
      date_closed: proc.dateClosed,
      viewed_count: proc.viewedCount,
      price_max: null,
      price_min: null,
      price_avg: null,
      min_bid_count: 1,
      bin_count: 1,
      contract_id: 234524,
      inherit_proc_id: proc.inherit_proc_id
    }
  })
}
